export default "__VITE_ASSET__UzHWJt02__"